<template lang='pug' src='./nav-mobile.pug'></template>

<script>
import Icon from 'components/icon/icon'
import { openModal } from '@/methods'

export default {
  data () {
    return {
      drawerOpen: false,
      active: '',
      subActive: ''
    }
  },
  computed: {
    links () {
      return this.$router.options.routes
    },
    props () {
      return this.$store.state.app.global
    }
  },
  components: {
    Icon
  },
  mixins: [openModal],
  methods: {
    openLink (i) {
      if (this.active === i) {
        this.active = ''
      } else {
        this.active = i
      }
    },
    openSubLink (j, link) {
      if (link.grandchildren) {
        if (this.subActive === j) {
          this.subActive = ''
        } else {
          this.subActive = j
        }
      } else {
        this.$router.push(link.path)
        this.$store.dispatch('VIEW_DRAWER', false)
        this.active = ''
      }
    },
    openSubSubLink (k, link) {
      this.$router.push(link.path)
      this.$store.dispatch('VIEW_DRAWER', false)
      this.subActive = ''
      this.active = ''
    },
    toggleDrawer () {
      this.$store.state.drawer ? this.$store.dispatch('VIEW_DRAWER', false) : this.$store.dispatch('VIEW_DRAWER', true)
    },
    closeDrawer () {
      this.$store.dispatch('VIEW_DRAWER', false)
    },
    openAppointment (path) {
      this.$router.push(path)
      this.$store.dispatch('VIEW_DRAWER', false)
      this.subActive = ''
      this.active = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// nav-mobile.vue?c9f07858